export default __webpack_public_path__ + "static/media/help.2b4a7853.svg";